import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IPODeleteAwaitingGRNFilterBody, IPODeleteAwaitingGrnPostResponse } from "@/api_framework/api_modals/Inventory";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { setPoAwaitingGRNDelete } from "@/app_redux/reducers/slices/auth/inventory_slice";

AxiosCurlirize(axios, () => {});
type InventoryTaxCreateAPIResponse = { status: boolean; message: string };

export const useAwaitingGRNDeletePOAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (filterParams: IPODeleteAwaitingGRNFilterBody) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: InventoryTaxCreateAPIResponse = await axios
          .post(INVENTORY_MODULE?.AWAITING_GRN_PO_DELETE?.baseURL ?? "", filterParams, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IPODeleteAwaitingGrnPostResponse>) => {
            if (res.data.status === true) {
              dispatch(setPoAwaitingGRNDelete({ data: res.data.data }));
              return { status: true, message: "batch" };
            } else {
              dispatch(setPoAwaitingGRNDelete({ data: null }));
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            dispatch(setPoAwaitingGRNDelete({ data: null }));
            return { status: false, message: null };
          });
        return response;
      } catch (e: any) {
        dispatch(setPoAwaitingGRNDelete({ data: null }));
      }
    },
    [dispatch],
  );
  return { execute };
};
